import { render, staticRenderFns } from "./ArtistItem.vue?vue&type=template&id=d2e141b0"
import script from "./ArtistItem.vue?vue&type=script&lang=ts"
export * from "./ArtistItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports